import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export enum DateFormat {
  DEFAULT = 'MM-DD-YYYY',
  EST_DEFAULT = 'MM-DD-YYYY HH:mm EST',
  EST_WITH_DOTS = 'MM.DD.YYYY HH:mm EST',
  WITH_TIME = 'MM-DD-YYYY HH:mm',
  DATE_FILTER = 'YYYY-MM-DD',
  DATE_FILTER_WITH_TIME = 'YYYY-MM-DD HH:mm:ss',
  DATE_FILTER_WITH_TIME_ET = 'YYYY-MM-DD HH:mm:ss -0500',
}

export function formatDate(unix: number = 0, withTime: boolean = true) {
  let format = withTime ? DateFormat.WITH_TIME : DateFormat.DEFAULT;

  return unix ? dayjs.unix(unix).format(format) : '-';
}

export function formatTimestampToUtcDate(
  date?: string,
  format: DateFormat = DateFormat.WITH_TIME,
) {
  return date ? dayjs.utc(date).format(format) : '-';
}
